import { AbstractControl, ValidatorFn } from '@angular/forms';

export function contactTypeValidate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.parent.value.column_type.value !== 'Sem Contato' && !control.value) {
      return { contact_type: true };
    }
    return null;
  };
}

export function returnDateValidate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.parent.value.column_type.value !== 'Visita' && isReturnDateEmpty(control.value)) {
      return { return_date: true };
    }

    return null;
  };
}

export function visitDateValidate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.parent.value.column_type.value === 'Visita' && (control.value.date === null || control.value.hour === null)) {
      return { visit_date: true };
    }

    return null;
  };
}

export function descriptionValidate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value) {
      return { description: true };
    }

    return null;
  };
}

export function validateCPF(control: AbstractControl): { [key: string]: boolean } | null {
  let Soma = 0;
  let Resto = 0;
  Soma = 0;
  if (!control.value) {
    return null;
  }
  if (control.value.length !== 11 ||
    control.value === '00000000000' ||
    control.value === '11111111111' ||
    control.value === '22222222222' ||
    control.value === '33333333333' ||
    control.value === '44444444444' ||
    control.value === '55555555555' ||
    control.value === '66666666666' ||
    control.value === '77777777777' ||
    control.value === '88888888888' ||
    control.value === '99999999999') { return { cpf: true }; }

  for (let i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(control.value.substring(i - 1, i), null) * (11 - i);
  }
  Resto = (Soma * 10) % 11;

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0;
  }
  if (Resto !== parseInt(control.value.substring(9, 10), null) ) {
    return { cpf: true };
  }

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(control.value.substring(i - 1, i), null) * (12 - i);
  }
  Resto = (Soma * 10) % 11;

  if ((Resto === 10) || (Resto === 11))  {
    Resto = 0;
  }

  if (Resto !== parseInt(control.value.substring(10, 11), null) ) {
    return { cpf: true };
  }
  return null;
}

export function validateDateRange(control: AbstractControl): { [key: string]: boolean } | null {
  const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 12)); // 12 years ago
  const selectedDate = new Date(new Date(control.value).setFullYear(new Date(control.value).getFullYear()));

  if (selectedDate > maxDate) {
    return { birth_date: true };
  }

  return null;
}

export function validateHaveCep(control: AbstractControl): { [key: string]: boolean } | null {
  if (!control.parent) {
    return null;
  }

  if (control.parent.value.zip_code && !control.value) {
    return { no_cep: true };
  }
  return null;
}

function isReturnDateEmpty(returnDate) {
  return !returnDate || !returnDate.name || !returnDate.value;
}
